import React, { useEffect, useState } from 'react';
import { fetchSubscriptionStatus } from '../services/emailAlertsApi';

/**
 * A thin banner from 7 days before the plan's end date, with the days left (Email & Reports
 * design, "Subscription reminders"). The date comes from the server's own lock check, so the
 * banner, the reminder emails and the lock always agree.
 *
 * Asked once when it mounts — no timer, the database is billed for every wake-up. It can be
 * hidden for the rest of the session.
 */
const DISMISS_KEY = 'invexis:planBannerDismissed';

const fmtDate = (iso) => {
  const d = new Date(`${iso}T00:00:00Z`);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('en-GB', { timeZone: 'UTC', day: 'numeric', month: 'short', year: 'numeric' });
};

const SubscriptionEndingBanner = () => {
  const [status, setStatus] = useState(null);
  const [hidden, setHidden] = useState(() => {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (_) { return false; }
  });

  useEffect(() => {
    let cancelled = false;
    fetchSubscriptionStatus().then((s) => { if (!cancelled) setStatus(s); });
    return () => { cancelled = true; };
  }, []);

  if (hidden || !status || !status.showBanner || status.daysLeft === null || status.daysLeft === undefined) return null;

  const days = Number(status.daysLeft);
  const message = days === 0
    ? 'Your INVEXIS plan ends today — access ends at midnight.'
    : `Your INVEXIS plan ends in ${days} day${days === 1 ? '' : 's'} (${fmtDate(status.endDate)}).`;

  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        padding: '6px 40px 6px 12px',
        backgroundColor: days <= 1 ? '#fef2f2' : '#fffbeb',
        borderBottom: `1px solid ${days <= 1 ? '#fecaca' : '#fde68a'}`,
        color: days <= 1 ? '#991b1b' : '#92400e',
        fontSize: '13px',
        position: 'relative',
        textAlign: 'center',
      }}
    >
      <span>{message} Renew from ☰ → My Subscription Period, or write to support@invexis.co.in.</span>
      <button
        type="button"
        aria-label="Hide this message"
        onClick={() => {
          setHidden(true);
          try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (_) { /* ignore */ }
        }}
        style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', fontSize: '14px' }}
      >
        ✕
      </button>
    </div>
  );
};

export default SubscriptionEndingBanner;
